{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Összes opció mutatása",
  "Spoiler_Reveal_Tooltip": "Kattints a megjelenítéshez!",
  "VerticalEmbed_Event_Error_Subtitle": "This event has been deleted, replace it with another event.",
  "Viewer_Toolbar_Twitter_Tooltip": "Tweetelem",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "Összecsukott elem",
  "Spoiler_Reveal_Video_CTA": "Videó mutatása",
  "VerticalEmbed_Pricing_Plan": "Plan only",
  "Image_Expand_Button_AriaLabel": "Kép kibontása",
  "VerticalEmbed_From_Price": "From",
  "Poll_Viewer_ShowAllResults_CTA": "Az összes eredmény mutatása",
  "Spoiler_Reveal_Image_Placeholder": "Ez a kép spoilert tartalmaz",
  "VerticalEmbed_Ribbon": "Sale",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Keresőcsúszka",
  "VerticalEmbed_Error_Subtitle": "This item has been deleted, replace it with another item.",
  "Poll_Viewer_Multiselect_Footer": "Egynél több válaszra is szavazhatsz.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "További hangvezérlők megjelenítése",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Failed to load service",
  "Fullscreen_Close_Button_AriaLabel": "Bezárás",
  "VerticalEmbed_Event_Fetch_Error_Title": "Failed to load event",
  "UploadFile_Viewer_Loader": "{{fileType}} betöltése",
  "Polls_Plugin_User_Avatar_Alt": "User avatar",
  "Preview_ReadMore_Label": "Bővebb információk",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Failed to load product",
  "Fullscreen_Shrink_Button_AriaLabel": "Shrink",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Hangerő",
  "Spoiler_Reveal_Gallery_Placeholder": "Ez a galéria spoilert tartalmaz (lelövi a poént)",
  "Fullscreen_Expand_Button_AriaLabel": "Expand",
  "VerticalEmbed_Bookings_Button": "Foglalás most",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Némítás feloldása",
  "Spoiler_Reveal_Gallery_CTA": "Galéria mutatása",
  "Poll_Viewer_ShowLess_CTA": "Kevesebb mutatása",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Némítás",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+{{anonNumber}} névtelen",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Követem",
  "VerticalEmbed_Products_Button": "Vásárlás most",
  "Poll_Viewer_Toast_Error_ServerDown": "Nem sikerült csatlakozni a szerverhez. Próbálkozz ismét később!",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} felhasználó szavazott erre a válaszra",
  "Poll_Viewer_VoteCount": "{{number}} szavazat",
  "VerticalEmbed_Events_Button": "Regisztráció most",
  "Spoiler_Reveal_Image_CTA": "Kép mutatása",
  "Poll_Viewer_Toast_Error_Connection": "Nincs internet. Ellenőrizd a kapcsolatot!",
  "Poll_Viewer_Visibility_Owner_Footer": "Csak te láthatod az eredményeket.",
  "VerticalEmbed_Booking_Error_Title": "Service deleted",
  "VerticalEmbed_Product_Error_Title": "Product deleted",
  "VerticalEmbed_Fetch_Error_Subtitle": "Unable to load item information.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} felhasználó szavazott erre a válaszra",
  "VerticalEmbed_Event_Error_Title": "Event deleted",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "Kibontott elem",
  "Audio_Plugin_Cover_Alt": "Audio cover",
  "Spoiler_Reveal_Video_Placeholder": "Ez a videó spoilert tartalmaz",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "Unable to load product information.",
  "VerticalEmbed_Fetch_Error_Title": "Failed to load item",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "This product has been deleted, replace it with another product.",
  "VerticalEmbed_Booking_Error_Subtitle": "This service has been deleted, replace it with another service.",
  "Preview_SeeFullPost_Label": "Teljes bejegyzés megjelenítése",
  "UploadFile_Viewer_Download": "{{fileType}} letöltése",
  "VerticalEmbed_Units_Hour": "{{hours}} óra",
  "VerticalEmbed_Units_Minute": "{{minutes}} perc",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "Unable to load event information.",
  "VerticalEmbed_Error_Button": "Replace",
  "VerticalEmbed_Error_Title": "Item deleted",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "Unable to load service information.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
